import { useEffect, useState } from "react";
import { addIncome } from "./TransactionService";
import { getAllAccounts } from "../accounts/AccountService";
import { getAllCategories } from "../categories/CategoryService";
import { getAllTags } from "../tags/TagService";

export default function IncomeForm(){

  const [accounts,setAccounts]=useState([]);
  const [categories,setCategories]=useState([]);
  const [tags,setTags]=useState([]);

  const [form,setForm]=useState({
    accountId:"",
    categoryId:"",
    amount:"",
    date:"",
    description:"",
    tags:[]
  });

  useEffect(()=>{ load(); },[]);

  const load = async ()=>{
    setAccounts(await getAllAccounts());
    setCategories(await getAllCategories());
    setTags(await getAllTags());
  };

  const toggleTag = (id)=>{
    setForm(f=>({
      ...f,
      tags: f.tags.includes(id) ? f.tags.filter(t=>t!==id) : [...f.tags,id]
    }));
  };

  const submit = async (e)=>{
    e.preventDefault();
    await addIncome(form);
    alert("Income added");
  };

  return (
    <form onSubmit={submit}>
      <div className="card">
        <div className="card-title">Add Income</div>
        <div className="form-grid">
      
          <select className="input" onChange={e=>setForm({...form,accountId:e.target.value})} required>
        <option value="">Select Account</option>
        {accounts.map(a=><option key={a.id} value={a.id}>{a.accountName}</option>)}
      </select>

        <select className="input" onChange={e=>setForm({...form,categoryId:e.target.value})} required>
        <option value="">Select Category</option>
        {categories.map(c=><option key={c.id} value={c.id}>{c.categoryName}</option>)}
      </select>

      <input className="input" type="number" placeholder="Amount"
        onChange={e=>setForm({...form,amount:e.target.value})} required />

      <input className="input" type="date"
        onChange={e=>setForm({...form,date:e.target.value})} required />
        </div>

        <textarea className="input form-full" placeholder="Description"
        onChange={e=>setForm({...form,description:e.target.value})} />


      {/* Tags */}
      <div style={{ marginTop:"15px", display:"flex", flexWrap:"wrap", gap:"10px" }}>
        {tags.map(t=>(
          <label key={t.id}>
            <input type="checkbox" onChange={()=>toggleTag(t.id)} />
            {t.tagName}
          </label>
        ))}
      </div>
        <div style={{ marginTop:"20px", textAlign:"right" }}>
            <button className="btn btn-primary" type="submit">Save Income</button>
        </div>
      </div>

      
      
    </form>
  );
}
